(function () {
    'use strict';

    var module = angular.module('uwAgenda.users', [
        'uwAgenda.help',
        'uwAgenda.global',
        'angularFileUpload'
    ]);
    module.constant('UserBroadcast', {
        "Deactivated": "user:deactivated",
        "FilterRefresh": "user:filterRefresh",
        "FilterCalculate": "user:filterCalculate",
        "ContactInfoCountryChanged": "contactinfo:countrychanged",
    });

    module.config(['$stateProvider', 'HelpCategoryEnum', UsersConfig]);

    function UsersConfig($stateProvider, HelpCategoryEnum) {
        $stateProvider
            .state('Home.Users', {
                url: 'Users',
                templateUrl: '/app/users/templates/users-overview.template.html',
                controller: 'UsersOverviewController',
                controllerAs: 'vm',
                resolve: {
                    users: ['$stateParams', 'SharedAgendaService', 'UserSearchPaginationService', 'ItemsPerPage',
                        function ($stateParams, SharedAgendaService, UserSearchPaginationService, ItemsPerPage) {
                            if (SharedAgendaService.data && SharedAgendaService.currentUser()) {
                                let sharedAgendaUserIds = SharedAgendaService.data.agendas.map(a => a.owner.id)
                                
                                UserSearchPaginationService.init(
                                    SharedAgendaService.currentUser().id,
                                    SharedAgendaService.data.currentAgenda.id,
                                    false,
                                    ItemsPerPage.UserCards.value,
                                    sharedAgendaUserIds,
                                    null);

                                return UserSearchPaginationService.search();
                            }
                            else {
                                return null;
                            }
                        }],

                    rolesForUser: ['SharedAgendaService', 'AdministrationService', function (SharedAgendaService, AdministrationService) {
                        const user = SharedAgendaService.getLoggedInUserData();
                        if (user && user.id) {
                            return AdministrationService.rolesForUser(user.id);
                        } else {
                            return [];
                        }
                    }],

                    grouppractices: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.grouppractices(false);
                    }],
                },
                params: {
                    syncedOnly: false,
                    helpCategory: HelpCategoryEnum.UserGeneral,
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'users' | translate}}"
                }
            })
            .state('Home.UserDetail', {
                abstract: true,
                url: 'Users/Detail/:userId',
                templateUrl: '/app/users/templates/edit-user.template.html',
                controller: 'EditUserController',
                controllerAs: 'vm',
                resolve: {

                    user: ['$stateParams', 'UserService', 'SharedAgendaService', function ($stateParams, UserService, SharedAgendaService) {
                        // edit or new
                        if ($stateParams.userId) {
                            return UserService.get($stateParams.userId, SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id, false, true);
                        } // if
                        else {
                            // return null -> new User Object will be created
                            return null;
                        }
                    }],

                    roles:  ['SharedAgendaService', 'AdministrationService', function (SharedAgendaService, AdministrationService) {
                        const user = SharedAgendaService.getLoggedInUserData();
                        if (user && user.id) {
                            return AdministrationService.rolesForUser(user.id);
                        } else {
                            return AdministrationService.roles();
                        }
                    }],

                    licences: ['LicenceService', function (LicenceService) {
                        return LicenceService.queryLicence();
                    }],

                    languages: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.languages();
                    }],

                    mainUserIds: ['UserService', 'SharedAgendaService', '$stateParams', function (UserService, SharedAgendaService, $stateParams) {
                        if ($stateParams.userId) {
                            // todo main-user noch ändern
                            return [];
                            //return UserService.getMainUserIds($stateParams.userId, SharedAgendaService.data.currentAgenda.id);
                        } else {
                            return [];
                        }
                    }],

                    grouppractices: ['UserDetailService', function (UserDetailService) {
                        return UserDetailService.loadGroupPractices(); // loaded in parent-view for single-load
                    }],

                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda UserDetail',
                            serie: true,
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/bootstrap-fileinput.css',
                                '/assets/lib/lazy-loaded/profile.css',

                                '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                                '/assets/lib/lazy-loaded/bootstrap-fileinput.js',


                                '/assets/lib/lazy-loaded/profile.min.js'
                            ]
                        });
                    }]
                }
            })

            .state('Home.UserDetail.Profile', {
                templateUrl: '/app/users/templates/edit-user-profile.template.html',
                data: {
                    requiresLogin: true
                },
                params: {
                    helpCategory: HelpCategoryEnum.UserProfileSettings
                },
                ncyBreadcrumb: {
                    parent: 'Home.Users',
                    label: '{{vm.ncyLabel | translate}}'
                }
            })

            .state('Home.UserDetail.Account', {
                templateUrl: '/app/users/templates/edit-user-account.template.html',
                data: {
                    requiresLogin: true
                },
                params: {
                    helpCategory: HelpCategoryEnum.UserAccountSettings
                },
                ncyBreadcrumb: {
                    parent: 'Home.Users',
                    label: '{{vm.ncyLabel | translate}}'
                }
            })

            .state('Home.UserDetail.Warning', {
                templateUrl: '/app/users/templates/edit-user-warning.template.html',
                data: {
                    requiresLogin: true
                },
                params: {
                    
                },
                ncyBreadcrumb: {
                    parent: 'Home.Users',
                    label: '{{vm.ncyLabel | translate}}'
                }
            })

            .state('Home.Website', {
                url: 'Website',
                templateUrl: '/app/users/templates/user-website.template.html',
                controller: 'UserWebsiteController',
                controllerAs: 'vm',
                resolve: {
                    website: ['SharedAgendaService', 'UserWebsiteService', function (SharedAgendaService, UserWebsiteService) {
                        return UserWebsiteService.getByUser(SharedAgendaService.currentUser().id);
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'user_website' | translate}}"
                }
            });
    }
})();